'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$16() {
  this.bf7 = null;
  this.bf5 = null;
  this.bf6 = false;
  this.bf3 = null;
  this.bf4 = false;
  this.bf8 = false;
  this.bf9 = false;
  this.bf7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$16 as $c_Lpresto_PrestoRouter$$anon$16 };
$p = $c_Lpresto_PrestoRouter$$anon$16.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$16;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$16() {
}
export { $h_Lpresto_PrestoRouter$$anon$16 as $h_Lpresto_PrestoRouter$$anon$16 };
$h_Lpresto_PrestoRouter$$anon$16.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bf7;
});
$p.t = (function() {
  if ((!this.bf6)) {
    this.bf5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bf6 = true;
  }
  return this.bf5;
});
$p.ae = (function() {
  if ((!this.bf4)) {
    this.bf3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bf4 = true;
  }
  return this.bf3;
});
$p.w = (function() {
  if ((!this.bf9)) {
    this.bf8 = false;
    this.bf9 = true;
  }
  return this.bf8;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$16, "presto.PrestoRouter$$anon$16", ({
  NG: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$16 as $d_Lpresto_PrestoRouter$$anon$16 };
//# sourceMappingURL=presto.-Presto-Router$$anon$16.js.map
